/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import { useSnackbar } from "notistack";
import { useState, useEffect } from "react";
import useNetwork from "src/hooks/useNetwork";
import { useLocation, useNavigate } from "react-router-dom";
import ProfileBottom from "./profile";
//
import DashboardIcon from "../navigationList/Icons/dashboard";
import ChatIcon from "../navigationList/Icons/chat";
import ReportIcon from "../navigationList/Icons/reports";
import SettingsIcon from "../navigationList/Icons/settings";
//
import useStyles from "./Styles";

const MainLayout = () => {
  const isOnline = useNetwork();
  const navigate = useNavigate();
  const location = useLocation();
  const locationValue = location.pathname;
  const [prevIsOnline, setPrevIsOnline] = useState(false);
  const [value, setValue] = useState(locationValue);
  const { enqueueSnackbar } = useSnackbar();
  const { classes } = useStyles();

  useEffect((): any => {
    if (!isOnline) {
      enqueueSnackbar("Internet connection lost. Please check your network.", {
        variant: "error",
      });
    } else if (isOnline && prevIsOnline) {
      enqueueSnackbar("Internet connection recovered.", {
        variant: "success",
      });
    }
  }, [isOnline, prevIsOnline, enqueueSnackbar]);

  useEffect(() => {
    if (!isOnline) setPrevIsOnline(true);
  }, [isOnline]);
  return (
    <Paper className={classes.paper} elevation={3}>
      <BottomNavigation
        className={classes.bottomNav}
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
          navigate(`${newValue}`);
        }}
      >
        <BottomNavigationAction
          className={(classes.bottomNavDif, classes.bottomNavLabel)}
          value="/"
          label="Dashboard"
          icon={<DashboardIcon fill={value === "/" ? "#4d1277" : "#000"} />}
        />
        <BottomNavigationAction
          className={(classes.hide, classes.bottomNavLabel)}
          value="/chats"
          label="Chats"
          icon={<ChatIcon fill={value === "/chats" ? "#4d1277" : "#000"} />}
        />
        <BottomNavigationAction
          className={classes.bottomNavLabel}
          value="/reports"
          label="Reports"
          icon={<ReportIcon fill={value === "/reports" ? "#4d1277" : "#000"} />}
        />
        <BottomNavigationAction
          className={classes.bottomNavLabel}
          value="/settings"
          label="Settings"
          icon={
            <SettingsIcon fill={value === "/settings" ? "#4d1277" : "#000"} />
          }
        />
        <ProfileBottom />
      </BottomNavigation>
    </Paper>
  );
};

export default MainLayout;
